import { combineReducers, configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { reducer as formReducer, reducer } from 'redux-form'
import { appReducer } from './app-reducer'
import { eClaimReducer } from './e-claim-reducer'
import { enrollmentReducer } from './enrollment-reducer'
import { relativeReducer } from './relative-reducer'
import { opdReducer } from './opd-reducer'
import { exerciseReducer } from './exercise-reducer'
import { insuranceReducer } from './insurance-reducer'
import { maternityReducer } from './maternity-reducer'
import { hepatitisReducer } from './hepatitis-reducer'

const reducers = combineReducers({
  app: appReducer,
  form: formReducer,
  eClaim: eClaimReducer,
  relative: relativeReducer,
  enrollment: enrollmentReducer,
  opd: opdReducer,
  exercise: exerciseReducer,
  insurance: insuranceReducer,
  maternity: maternityReducer,
  hepatitis: hepatitisReducer,
})

export type RootState = ReturnType<typeof reducers>

const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
})
export default store
